module.exports = __webpack_public_path__ + "img/PAGE_TITLE.be72a2e3.svg";